import { jsx as _jsx } from "react/jsx-runtime";
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
// @ts-expect-error no type definition
import seiueLogoCN from '../assets/seiue_logo_cn.png';
export const SeiueLogo = () => {
    const history = useHistory();
    return (_jsx(LogoWrapper, Object.assign({ style: {
            flexShrink: 0,
        }, onClick: () => {
            history.push('/');
        } }, { children: _jsx("img", { src: seiueLogoCN, style: {
                height: 26,
            } }, void 0) }), void 0));
};
const LogoWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-right: 24px;
  min-height: 40px;
  max-height: 52px;
  cursor: pointer;
  line-height: normal;
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2VpdWVMb2dvLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL0FwcExheW91dC9jb21wb25lbnRzL1NlaXVlTG9nby50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUlBLE9BQU8sRUFBRSxVQUFVLEVBQUUsTUFBTSxrQkFBa0IsQ0FBQTtBQUM3QyxPQUFPLE1BQU0sTUFBTSxtQkFBbUIsQ0FBQTtBQUV0QyxzQ0FBc0M7QUFDdEMsT0FBTyxXQUFXLE1BQU0sNkJBQTZCLENBQUE7QUFFckQsTUFBTSxDQUFDLE1BQU0sU0FBUyxHQUFhLEdBQUcsRUFBRTtJQUN0QyxNQUFNLE9BQU8sR0FBRyxVQUFVLEVBQUUsQ0FBQTtJQUM1QixPQUFPLENBQ0wsS0FBQyxXQUFXLGtCQUNWLEtBQUssRUFBRTtZQUNMLFVBQVUsRUFBRSxDQUFDO1NBQ2QsRUFDRCxPQUFPLEVBQUUsR0FBRyxFQUFFO1lBQ1osT0FBTyxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQTtRQUNuQixDQUFDLGdCQUVELGNBQ0UsR0FBRyxFQUFFLFdBQVcsRUFDaEIsS0FBSyxFQUFFO2dCQUNMLE1BQU0sRUFBRSxFQUFFO2FBQ1gsV0FDRCxZQUNVLENBQ2YsQ0FBQTtBQUNILENBQUMsQ0FBQTtBQUVELE1BQU0sV0FBVyxHQUFHLE1BQU0sQ0FBQyxHQUFHLENBQUE7Ozs7Ozs7OztDQVM3QixDQUFBIn0=